export const SHOP_PREFIX = '/shop';
export const PRODUCT_DETAILS = `${SHOP_PREFIX}/product/:objectID/:slug?`;
export const PRODUCT_DETAILS_ROOT = `${SHOP_PREFIX}/product`;
export const PRODUCT_DETAILS_AD = `${SHOP_PREFIX}/product-ad/:objectID/:slug?`;
export const CARD_PARTNER_ONBOARDING_APPLY = '/perpay-card/partner-application';
export const MARKETPLACE_PARTNER_ONBOARDING_APPLY =
    '/marketplace-card/partner-application';
export const SHOP_HOME = `${SHOP_PREFIX}/`;
export const PAYROLL_CONNECTION_INTRO = '/payroll-connection/intro';
